import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  initialTeamManagementPageState,
  TeamManagementItemData,
  TeamManagementListResponse,
  TeamManagementListStateType,
} from "../core/_model.team-management";

export const defaultPageState = {
  page: 1,
  itemsPerPage: 10,
};

export type ActionedTeam = {
  data: TeamManagementItemData | null;
  action: ActionsKey;
};

export type ActionedTeamManagement = {
  data: TeamManagementItemData;
  action: ActionsKey;
};

type TeamManagementDataType = {
  teamManagementList: any;
  detail: TeamManagementItemData | null;
  actioned: ActionedTeamManagement | null;
  totalItems?: number;
  setDetail: (detail: TeamManagementItemData | null) => void;
  setTeamManagementList: (roles: TeamManagementListResponse | null) => void;
  setActioned: (act: ActionedTeam | null) => void;
  pageState: any;
  setPageState: (state: any) => void;
  resetPageState: () => void;
};

export const useTeamManagementSaleStore = create<TeamManagementDataType>(
  (set) => ({
    teamManagementList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    pageState: defaultPageState,
    setDetail: (detail) => set((state) => ({ detail })),
    setTeamManagementList: (teamData) =>
      set(() => ({
        teamManagementList: teamData?.member,
        totalItems: teamData?.totalItems ?? 0,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);

export const useTeamManagementCabotageStore = create<TeamManagementDataType>(
  (set) => ({
    teamManagementList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    pageState: defaultPageState,

    setDetail: (detail) => set((state) => ({ detail })),
    setTeamManagementList: (teamData) =>
      set(() => ({
        teamManagementList: teamData?.member,
        totalItems: teamData?.totalItems ?? 0,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);

export const useTeamManagementListState = create<TeamManagementListStateType>(
  (set) => ({
    pageState: initialTeamManagementPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
